/* Bundle Guard — all-or-nothing for Multi-Step Bundle (client-side deterrent) */
(function () {
  "use strict";
  var BUSY = false;

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }
  function brokenGroups(cart) {
    var g = {};
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {}, bid = p._bundle_id;
      if (!bid) return;
      if (!g[bid]) g[bid] = { size: parseInt(p._bundle_size, 10) || 0, qty: 0, keys: [] };
      g[bid].qty += it.quantity; g[bid].keys.push(it.key);
    });
    return Object.keys(g).map(function (k) { return g[k]; })
      .filter(function (x) { return x.size > 0 && x.qty !== x.size; });
  }
  function clearGroups(broken) {
    var updates = {};
    broken.forEach(function (x) { x.keys.forEach(function (key) { updates[key] = 0; }); });
    if (!Object.keys(updates).length) return Promise.resolve();
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates })
    });
  }
  function refreshUI() {
    // Native Symmetry cart-drawer refresh
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }
  function sweep() {
    if (BUSY) return;
    getCart().then(function (cart) {
      var broken = brokenGroups(cart);
      if (!broken.length) return;
      BUSY = true;
      clearGroups(broken).then(refreshUI).then(function () {
        setTimeout(function () { BUSY = false; }, 200);
      });
    }).catch(function () {});
  }
  function isMutation(u) { return u && /\/cart\/(change|update)(\.js)?/.test(String(u)); }

  var of = window.fetch;
  if (of) window.fetch = function () {
    var u = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
    var pr = of.apply(this, arguments);
    if (!BUSY && isMutation(u)) pr.then(function () { sweep(); }).catch(function () {});
    return pr;
  };
  var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__bg = u; return oo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (!BUSY && isMutation(this.__bg)) this.addEventListener("loadend", function () { sweep(); });
    return os.apply(this, arguments);
  };
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", function () { setTimeout(sweep, 300); });
  else setTimeout(sweep, 300);
})();